// extracted by mini-css-extract-plugin
export default {"MenuGrid":"MainMenu_MenuGrid__wbRFR","CategoryItem":"MainMenu_CategoryItem__0m5U-","CategoryWrapper":"MainMenu_CategoryWrapper__3xYcV"};